var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysSupplier = function SvgSysSupplier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m2 14.5 1.721-1.801m0 0L5.533 14.5l2.116-2.094-1.814-1.8m-2.114 2.093 2.114-2.094m2.488-2.464c.307.305.673.548 1.076.714a3.36 3.36 0 0 0 2.55 0A3.303 3.303 0 0 0 14 5.81c0-.872-.35-1.709-.974-2.33a3.759 3.759 0 0 0-.806-.588 3.288 3.288 0 0 0-2.05-.356 3.253 3.253 0 0 0-1.847.944 3.286 3.286 0 0 0-.975 2.33c0 .872.35 1.709.975 2.33Zm0 0-2.488 2.464"
  })));
};
export default SvgSysSupplier;